import { type RingProgressFactory, RingProgress as MantineRingProgress } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import type { IProps } from "./progress-circle.types";

/**
 * Circular progress ring for displaying a percentage value visually, with an optional center label.
 * @param props - Mantine RingProgress props.
 * @returns The ProgressCircle component.
 */
const ProgressCircle = componentWrapper<RingProgressFactory, IProps>("ProgressCircle", (props, ref) => {
    return <MantineRingProgress ref={ref} {...props} />;
});

export { ProgressCircle };
